import type { ReactNode } from "react";

import clsx from "clsx";

import { CircleIcon } from "../../icons/circle";
import { PendingIcon } from "../../icons/pending";
import { SuccessIcon } from "../../icons/success";

import styles from "./badge.module.css";

export type BadgeVariants = "error" | "info" | "pending" | "success";

type BadgeProps = {
	showIcon?: boolean;
	text: string;
	variant: BadgeVariants;
};

function BadgeIcon({ variant }: { variant: BadgeVariants }): ReactNode {
	if (variant === "error" || variant === "info") {
		return <CircleIcon />;
	}
	if (variant === "pending") {
		return <PendingIcon />;
	}
	return <SuccessIcon />;
}

export function Badge({ showIcon = true, text, variant = "success" }: BadgeProps): ReactNode {
	return (
		<span
			className={clsx(styles.badge, "caption", styles[variant])}
			data-testid={`badge-${variant}`}
		>
			{showIcon && <BadgeIcon variant={variant} />}
			{text}
		</span>
	);
}
